// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pageson {
  background-color: #2d348e;
  color: white;
  width: 2.5rem;
  text-align: center;
  border-radius: 10px
}

.pagesof {
  background-color: white;
  color: black;
  width: 2.5rem;
  text-align: center;
  border-radius: 10px
}

#form1 {
  display: block;
}

#form2 {
  display: none;
}

#form3 {
  display: none;
}

#form {
  display: block;
}

.card-title {
  font-size: x-large;
  font-family: fantasy;
  font-weight: 100;
}

input[type=range],
.range {
  border-radius: 0.75em;
  overflow: hidden;
  margin-bottom: 1.5em;
}

input[type=range] {
  background-color: burlywood;
  box-shadow:
    0.3em 0.3em 0.4em var(--bs2) inset,
    -0.3em -0.3em 0.4em var(--bs1) inset;
  display: block;
  padding: 0 0.1em;
  width: 100%;
  height: 1.5em;
  appearance: none;
}

input[type=range]:focus {
  outline: transparent;
}

input[type=range]::-webkit-slider-thumb {
  background-color: #255ff4;
  border: 0;
  border-radius: 50%;
  box-shadow:
    -0.3em -0.3em 0.5em #0937aa inset,
    0 -0.2em 0.2em 0 #0004,
    0.3em 0.9em 0.8em #0007;
  cursor: pointer;
  position: relative;
  width: 1.3em;
  height: 1.3em;
  -webkit-transition: all var(--transDur) linear;
  transition: all var(--transDur) linear;
  z-index: 1;
  appearance: none;
}

input[type=range]:focus::-webkit-slider-thumb {
  background-color: #5583f6;
  box-shadow:
    -0.3em -0.3em 0.5em #0b46da inset,
    0 -0.2em 0.2em 0 #0004,
    0.3em 0.9em 0.8em #0007;
}

input[type=range]::-moz-range-thumb {
  background-color: #255ff4;
  border: 0;
  border-radius: 50%;
  box-shadow:
    -0.3em -0.3em 0.5em #0937aa inset,
    0 -0.2em 0.2em 0 #0004,
    0.3em 0.9em 0.8em #0007;
  cursor: pointer;
  position: relative;
  width: 1.3em;
  height: 1.3em;
  transform: translateZ(1px);
  -moz-transition: all var(--transDur) linear;
  transition: all var(--transDur) linear;
  z-index: 1;
  appearance: none;
}

input[type=range]:focus::-moz-range-thumb {
  background-color: #5583f6;
  box-shadow:
    -0.3em -0.3em 0.5em #0b46da inset,
    0 -0.2em 0.2em 0 #0004,
    0.3em 0.9em 0.8em #0007;
}

input[type=range]::-moz-focus-outer {
  border: 0;
}

.headerstyle {
  background-image: url('http://localhost:7777/LoginImages/reciept.png');
  width: 100vw;
  background-repeat: no-repeat;
  background-size: cover;
  height: 67vh;
}

.footerstyle {
  background-image: url('http://localhost:7777/LoginImages/footer.png');
  width: 100vw;
  background-repeat: no-repeat;
  background-size: cover;
  height: 19vh;
}

.hovereffect {
  transition: transform 0.5s, box-shadow 0.5s;
  border-radius: 10px;
  overflow: hidden;
}

.hovereffect:hover {
  transform: scale(1.1);
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.5);
  border: 1px solid rgba(0, 0, 0, 0.281);
}

.card-img-top {
  border-radius: 10px 10px 0 0;
}

.bidder_register_form {
  display: flex;
  width: 70vw;
  justify-content: space-evenly;
  margin-top: 5px;
  font-weight: bold;
}

.download_reciept_button {
  display: flex;
  justify-content: center
}

.searchTender {
  width: 40vw;
  height: 80%;
}

.register-pop {
  background: linear-gradient(rgba(255, 255, 255, 0.8), rgba(255, 255, 255, 0.8));
}

@media screen and (max-width: 768px) {
  .searchTender {
    width: 80vw;
    height: 80%;
  }
}


.loader {
  height: 100px;
  width: 100px;
  border: 12px solid #e3e3e3;
  border-radius: 50%;
  border-right-color: #2673e7;
  animation: spin 1s ease infinite;
}

.Adminloader {
  height: 100px;
  width: 100px;
  margin: auto;
  border: 12px solid #e3e3e3;
  border-radius: 50%;
  border-right-color: #2673e7;
  animation: spin 1s ease infinite;
}

@keyframes spin {
  100% {
    transform: rotate(360deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/Users/pages/innercss.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB;AACF;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB;AACF;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;;EAEE,qBAAqB;EACrB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B;;wCAEsC;EACtC,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,aAAa;EAGb,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB;;;2BAGyB;EACzB,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,8CAAsC;EAAtC,sCAAsC;EACtC,UAAU;EAEV,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB;;;2BAGyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB;;;2BAGyB;EACzB,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,0BAA0B;EAC1B,2CAAsC;EAAtC,sCAAsC;EACtC,UAAU;EAEV,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB;;;2BAGyB;AAC3B;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,sEAAsE;EACtE,YAAY;EACZ,4BAA4B;EAC5B,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,qEAAqE;EACrE,YAAY;EACZ,4BAA4B;EAC5B,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,uCAAuC;EACvC,sCAAsC;AACxC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,WAAW;EACX,6BAA6B;EAC7B,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb;AACF;;AAEA;EACE,WAAW;EACX,WAAW;AACb;;AAEA;EACE,+EAA+E;AACjF;;AAEA;EACE;IACE,WAAW;IACX,WAAW;EACb;AACF;;;AAGA;EACE,aAAa;EACb,YAAY;EACZ,0BAA0B;EAC1B,kBAAkB;EAClB,2BAA2B;EAC3B,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,0BAA0B;EAC1B,kBAAkB;EAClB,2BAA2B;EAC3B,gCAAgC;AAClC;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF","sourcesContent":[".pageson {\n  background-color: #2d348e;\n  color: white;\n  width: 2.5rem;\n  text-align: center;\n  border-radius: 10px\n}\n\n.pagesof {\n  background-color: white;\n  color: black;\n  width: 2.5rem;\n  text-align: center;\n  border-radius: 10px\n}\n\n#form1 {\n  display: block;\n}\n\n#form2 {\n  display: none;\n}\n\n#form3 {\n  display: none;\n}\n\n#form {\n  display: block;\n}\n\n.card-title {\n  font-size: x-large;\n  font-family: fantasy;\n  font-weight: 100;\n}\n\ninput[type=range],\n.range {\n  border-radius: 0.75em;\n  overflow: hidden;\n  margin-bottom: 1.5em;\n}\n\ninput[type=range] {\n  background-color: burlywood;\n  box-shadow:\n    0.3em 0.3em 0.4em var(--bs2) inset,\n    -0.3em -0.3em 0.4em var(--bs1) inset;\n  display: block;\n  padding: 0 0.1em;\n  width: 100%;\n  height: 1.5em;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n}\n\ninput[type=range]:focus {\n  outline: transparent;\n}\n\ninput[type=range]::-webkit-slider-thumb {\n  background-color: #255ff4;\n  border: 0;\n  border-radius: 50%;\n  box-shadow:\n    -0.3em -0.3em 0.5em #0937aa inset,\n    0 -0.2em 0.2em 0 #0004,\n    0.3em 0.9em 0.8em #0007;\n  cursor: pointer;\n  position: relative;\n  width: 1.3em;\n  height: 1.3em;\n  transition: all var(--transDur) linear;\n  z-index: 1;\n  -webkit-appearance: none;\n  appearance: none;\n}\n\ninput[type=range]:focus::-webkit-slider-thumb {\n  background-color: #5583f6;\n  box-shadow:\n    -0.3em -0.3em 0.5em #0b46da inset,\n    0 -0.2em 0.2em 0 #0004,\n    0.3em 0.9em 0.8em #0007;\n}\n\ninput[type=range]::-moz-range-thumb {\n  background-color: #255ff4;\n  border: 0;\n  border-radius: 50%;\n  box-shadow:\n    -0.3em -0.3em 0.5em #0937aa inset,\n    0 -0.2em 0.2em 0 #0004,\n    0.3em 0.9em 0.8em #0007;\n  cursor: pointer;\n  position: relative;\n  width: 1.3em;\n  height: 1.3em;\n  transform: translateZ(1px);\n  transition: all var(--transDur) linear;\n  z-index: 1;\n  -moz-appearance: none;\n  appearance: none;\n}\n\ninput[type=range]:focus::-moz-range-thumb {\n  background-color: #5583f6;\n  box-shadow:\n    -0.3em -0.3em 0.5em #0b46da inset,\n    0 -0.2em 0.2em 0 #0004,\n    0.3em 0.9em 0.8em #0007;\n}\n\ninput[type=range]::-moz-focus-outer {\n  border: 0;\n}\n\n.headerstyle {\n  background-image: url('http://localhost:7777/LoginImages/reciept.png');\n  width: 100vw;\n  background-repeat: no-repeat;\n  background-size: cover;\n  height: 67vh;\n}\n\n.footerstyle {\n  background-image: url('http://localhost:7777/LoginImages/footer.png');\n  width: 100vw;\n  background-repeat: no-repeat;\n  background-size: cover;\n  height: 19vh;\n}\n\n.hovereffect {\n  transition: transform 0.5s, box-shadow 0.5s;\n  border-radius: 10px;\n  overflow: hidden;\n}\n\n.hovereffect:hover {\n  transform: scale(1.1);\n  box-shadow: 0 0 20px rgba(0, 0, 0, 0.5);\n  border: 1px solid rgba(0, 0, 0, 0.281);\n}\n\n.card-img-top {\n  border-radius: 10px 10px 0 0;\n}\n\n.bidder_register_form {\n  display: flex;\n  width: 70vw;\n  justify-content: space-evenly;\n  margin-top: 5px;\n  font-weight: bold;\n}\n\n.download_reciept_button {\n  display: flex;\n  justify-content: center\n}\n\n.searchTender {\n  width: 40vw;\n  height: 80%;\n}\n\n.register-pop {\n  background: linear-gradient(rgba(255, 255, 255, 0.8), rgba(255, 255, 255, 0.8));\n}\n\n@media screen and (max-width: 768px) {\n  .searchTender {\n    width: 80vw;\n    height: 80%;\n  }\n}\n\n\n.loader {\n  height: 100px;\n  width: 100px;\n  border: 12px solid #e3e3e3;\n  border-radius: 50%;\n  border-right-color: #2673e7;\n  animation: spin 1s ease infinite;\n}\n\n.Adminloader {\n  height: 100px;\n  width: 100px;\n  margin: auto;\n  border: 12px solid #e3e3e3;\n  border-radius: 50%;\n  border-right-color: #2673e7;\n  animation: spin 1s ease infinite;\n}\n\n@keyframes spin {\n  100% {\n    transform: rotate(360deg);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
